// Работа с Cache API для кеширования изображений

export class CacheManager {
    constructor() {
        this.cacheName = 'gallery-images-cache-v1';
    }

    async init() {
        this.cache = await caches.open(this.cacheName);
    }

    async cacheImage(url, imageBlob) {
        if (!this.cache) await this.init();
        
        const response = new Response(imageBlob, {
            headers: { 'Content-Type': 'image/jpeg' }
        });
        await this.cache.put(url, response);
    }

    async cacheVideo(url, videoBlob) {
        if (!this.cache) await this.init();
        
        const response = new Response(videoBlob, {
            headers: { 'Content-Type': videoBlob.type || 'video/mp4' }
        });
        await this.cache.put(url, response);
    }

    async getCachedImage(url) {
        if (!this.cache) await this.init();
        
        const response = await this.cache.match(url);
        return response ? await response.blob() : null;
    }

    async getCachedVideo(url) {
        if (!this.cache) await this.init();
        
        const response = await this.cache.match(url);
        return response ? await response.blob() : null;
    }

    async clearAll() {
        const cacheNames = await caches.keys();
        await Promise.all(
            cacheNames.map(cacheName => caches.delete(cacheName))
        );
    }

    async getCacheSize() {
        if (!this.cache) await this.init();
        
        const keys = await this.cache.keys();
        let totalSize = 0;
        
        for (const key of keys) {
            const response = await this.cache.match(key);
            if (response) {
                const blob = await response.blob();
                totalSize += blob.size;
            }
        }
        
        return totalSize;
    }
}
